import { PlusIcon } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/core/button';

import { WizardStep, type WizardStepProps } from './wizard';

export type OptionalWizardStepProps = WizardStepProps & {
  label: string;
  defaultExpanded?: boolean;
};

export function OptionalWizardStep({
  step,
  label,
  complete,
  onSubmitStep,
  defaultExpanded = false,
  children,
}: OptionalWizardStepProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  if (!expanded) {
    return (
      <WizardStep step={step} onSubmitStep={() => true}>
        <Button
          type="button"
          variant="outline"
          className="h-13 justify-start"
          onClick={() => setExpanded(true)}
        >
          <PlusIcon />
          {label}
        </Button>
      </WizardStep>
    );
  }

  return (
    <WizardStep step={step} complete={complete} onSubmitStep={onSubmitStep}>
      {children}
    </WizardStep>
  );
}
